module.exports = __webpack_public_path__ + "static/20-FRA-KIR.fda8ec21.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/20-FRA-KIR.png
// module id = 616
// module chunks = 35783957827783